module.exports = __webpack_public_path__ + "img/contact-info-row-honda.5144f8d8.png";